module.exports = __webpack_public_path__ + "static/img/A144.2944b640.jpg";